module.exports = "pegasus_template/assets/themecapture1/large/53.png";